<template>
    <div class="interface">
        <div class="container">
            <div class="wordone">
                <p>404 <span>NOT FOUND</span></p>
            </div>
            <div class="wordtwo">
              <p>抱歉，未找到该页面</p>
            </div>
            <div class="btn">
                <div @click="go_back()">返回首页</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    created(){},
    mounted(){},
    methods:{
        go_back(){
            this.$router.push('/careerArchives')
        }
    },
}
</script>
<style lang="less" scoped>
.interface{
    width:100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: #F5F5F5;
}
.container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,calc(-50% - 12px));
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    max-width: 1240px;
}
.wordone {
    font-size: 76px;
    line-height: 100px;
    font-weight: normal;
    color: #b3b3b3;
    text-align: center;
}
.wordone p {
    font-weight: bold;
    font-family: 'Conv_GothamPro-Bold.woff';
}
.wordone span {
    font-weight: normal;
    font-family: 'Gotham-Light.otf';
}
.wordtwo {
    font-size: 18px;
    line-height: 28px;
}
.wordtwo p {
    color: rgb(173, 173, 173);
    text-align: center;
    font-family: 微软雅黑;
    margin-top: 15px;
}
.btn{
    text-align: center;
    margin-top: 6px;
    > div{
    background-color: #3C8CEB;
    color: white;
    width: 160px;
    height: 45px;
    line-height: 45px;
    font-size: 18px;
    margin-top: 28px;
    margin-left: auto;
    margin-right: auto;
    font-family: 微软雅黑;
    text-align: center !important;
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    transition: all 0.2s linear 0s;
    cursor: pointer;
    }
}

</style>